import React from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';

import useDateFnsLocale from 'services/useDateFnsLocale';

interface DateLocalizationProviderProps {
    children: React.ReactNode;
}

export const DateLocalizationProvider = ({ children }: DateLocalizationProviderProps) => {
    const dateFnsLocale = useDateFnsLocale();

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
            {children}
        </LocalizationProvider>
    );
};
